export default __webpack_public_path__ + "static/dashboardImage-845d7bdcf31dd2b12954f3c2aaf8c2bc.png";